import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getBreakpointIndex from "@toolkit/Framework/Common/Utilities/getBreakpointIndex";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";

export default (values: BreakpointValue[], breakpoint: BreakpointKey, theme: StyledTheme): BreakpointValue[] => {
    const startIndex = getBreakpointIndex(breakpoint, theme);
    return values.map((value, index) => (index >= startIndex ? value : null));
};
